import { GameData } from 'react-easyrocket';
import { getGameBadges } from '../../utils/getGamesBadges';

interface GameBadgesProps {
  gameCategories: NonNullable<GameData['categories']>;
  gameSource?: number;
  isWagering?: boolean;
}

export const GameBadges = ({ gameCategories = [] }: GameBadgesProps) => {
  const badges = getGameBadges(gameCategories);

  return (
    <div className="absolute inset-0 z-[3] flex flex-wrap content-start items-start justify-start ">
      {badges.map((Badge, index) => (
        <Badge key={index} />
      ))}
    </div>
  );
};
